<div class="dialogue-container">
  <div class="dialogue-content">
    <!-- <div class="quote-icon">
      <i class="fas fa-quote-left"></i>
    </div> -->
    <blockquote class="dialogue-quote">
      <div class="actor-row">
        <div class="actor-image" *ngIf="currentDialogue?.character_image; else avatarFallback">
          <img
            [src]="currentDialogue?.character_image"
            [alt]="currentDialogue?.character_name || 'Character image'"
          />
        </div>
        <ng-template #avatarFallback>
          <div class="actor-fallback">
            <i class="fas fa-user"></i>
          </div>
        </ng-template>
      </div>
      <p class="dialogue-text">{{ currentDialogue?.dialogue_text }}</p>
      <footer class="dialogue-attribution">
        <span class="character-name">- {{ currentDialogue?.character_name || 'Unknown' }}</span>
      </footer>
    </blockquote>
    <div class="quote-decorations">
      <div class="decoration-line"></div>
    </div>
  </div>
</div>
